import React from 'react';
import { withRouter } from 'react-router';
import _ from 'lodash';
import AppSelect from '../AppSelect';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker, { utils } from 'react-modern-calendar-datepicker';

class AppTableFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: this._getInitialFilter(props)
    };

    props.onInit(this);
  }

  getFilter() {
    return this.state.filter;
  }

  /**
   *
   * @param {Object} props Passed props
   */
  _getInitialFilter(props) {
    let filter = null;
    if (props.location.query.filter) {
      filter = this._joinFilters(props.filter, props.location.query.filter);
    } else {
      filter = props.filter;
    }

    return this._prepareFilter(filter);
  }

  _joinFilters(filter, otherFilters) {
    const mainFilter = [...filter];

    otherFilters.forEach(otherFilter => {
      const existingFilter = mainFilter.find(x => x.name == otherFilter.name);
      if (existingFilter) {
        const indexOf = mainFilter.indexOf(existingFilter);
        mainFilter[indexOf] = otherFilter;
        // mainFilter[indexOf] = {...existingFilter, ...otherFilter};
      } else {
        mainFilter.push(otherFilter);
      }
    });
    return mainFilter;
  }

  _prepareFilter(filters) {
    if (!filters) return [];

    filters.forEach((filter, index) => {
      if (
        filters[index].value === null ||
        typeof filters[index].value === 'undefined'
      ) {
        filters[index].value = '';
      }
    });

    return filters;
  }

  _getElements(props) {
    const elements = [];

    if (!props.filter || props.filter.length == 0) {
      return elements;
    }

    props.filter.forEach((singleFilter, index) => {
      let innerElement = null;
      switch (singleFilter.type) {
        case 'term':
          innerElement = this._getTermField(singleFilter, index);
          break;
        case 'datetime':
          innerElement = this._getDatetimeField(singleFilter, index);
          break;
        case 'select':
          innerElement = this._getSelectField(singleFilter, index);
          break;
      }

      if (innerElement) {
        elements.push(
          <div
            style={{ display: 'inline-block' }}
            className="single-filter-field"
            data-index={index}
            key={`filter${index}`}
          >
            {innerElement}
          </div>
        );
      }
    });

    return elements;
  }

  _debounceFilter = _.debounce(() => this._triggerFilter(), 200);

  _getTermField(singlefilter, index) {
    const label = singlefilter.label ? singlefilter.label : null;
    return (
      <div className="filter-field" data-index={index}>
        <label>{label}</label>
        <input
          type="search"
          placeholder="Search"
          value={
            this.state.filter[index] ? this.state.filter[index].value : null
          }
          onChange={e => {
            this._changedFilter(singlefilter, e.target.value);
            this._debounceFilter();
          }}
        />
      </div>
    );
  }

  // Render regular HTML input element
  _renderCustomInput = (ref, index) => {
    const ref2 = ref.ref;
    return (
      <input
        readOnly
        ref={ref2} // necessary
        placeholder={'Select a day'}
        value={this.state.filter[index] ? this.state.filter[index].value : ''}
        className="filter-datetime" // a styling class
      />
    );
  };

  _getDatetimeField(singleFilter, index) {
    const label = singleFilter.label ? singleFilter.label : singleFilter.name;
    return (
      <div className="filter-field" data-index={index}>
        <label style={{ display: 'block' }}>{label}</label>
        <DatePicker
          onChange={e => {
            this._changedFilter(singleFilter, e);
          }}
          inputPlaceholder="Select a day"
          renderInput={ref => this._renderCustomInput(ref, index)} // render a custom input
          colorPrimary={'red'}
          colorPrimaryLight="rgba(75, 207, 250, 0.4)"
          shouldHighlightWeekends
          maximumDate={utils('en').getToday()}
        />
      </div>
    );
  }

  _getSelectField(singleFilter, index) {
    const label = singleFilter.label ? singleFilter.label : singleFilter.name;

    return (
      <div className="filter-field" data-index={index}>
        <label>{label}</label>
        <AppSelect
          textFieldProps={{
            disableUnderline: true,
            label: false,
            InputLabelProps: {
              shrink: true
            }
          }}
          {...singleFilter.options}
          onChange={itemId => {
            this._changedFilter(singleFilter, itemId, true);
          }}
          value={
            this.state.filter[index] ? this.state.filter[index].value : null
          }
        />
      </div>
    );
  }

  _changedFilter(filter, filterValue, reload = false) {
    let formatedValue = filterValue;
    if (filterValue.day) {
      formatedValue = `${filterValue.day}/${filterValue.month}/${filterValue.year}`;
    }

    const filterCopy = [...this.state.filter];
    let currentFilter = null;

    if (filter.name) {
      currentFilter = filterCopy.find(x => x.name === filter.name);
    } else {
      currentFilter = filterCopy.find(x => x.field === filter.field);
    }

    if (currentFilter) {
      currentFilter.value = formatedValue;
      filterCopy[filterCopy.indexOf(currentFilter)] = currentFilter;
    } else {
      filterCopy.push({
        ...filter,
        value: formatedValue
      });
    }

    this.setState(
      {
        filter: filterCopy
      },
      () => {
        if (reload) {
          this._triggerFilter();
        }
      }
    );
  }

  _triggerFilter() {
    this.props.onFilter(this.state.filter);
  }

  _clearFilter() {
    const newFilter = [...this.state.filter];
    newFilter.forEach((filter, index) => {
      newFilter[index].value = '';
    });

    this.setState(
      {
        filter: newFilter
      },
      () => {
        this.props.onFilter(this.state.filter);
      }
    );
  }

  _getClearFilterButton() {
    let allEmpty = true;

    this.state.filter.forEach(filter => {
      if (filter.value) allEmpty = false;
    });

    if (allEmpty) return null;

    return (
      <button
        type="button"
        className="button-info"
        onClick={() => this._clearFilter()}
      >
        Clear
      </button>
    );
  }

  render() {
    const elements = this._getElements(this.props);

    if (elements.length == 0) return null;

    const clearFilterButton = this._getClearFilterButton();

    return (
      <form
        onSubmit={() => this._triggerFilter()}
        style={{ padding: this.props.padded ? 10 : 0 }}
      >
        {elements}
        {clearFilterButton}
        <button
          type="submit"
          className="button-round"
          style={{ marginTop: this.props.columnForm ? 20 : 0 }}
          onClick={e => {
            e.preventDefault();
            this._triggerFilter();
            return false;
          }}
        >
          Search
        </button>
      </form>
    );
  }
}

AppTableFilter.defaultProps = {
  onInit: () => {},
  onFilter: () => {},
  format: 'DD/MM/YYYY HH:mm:ss'
};

export default withRouter(AppTableFilter);
